import React from 'react'
import PropTypes from 'prop-types'

import { MediaContainer, HeroImage, HeroVideo, HeroVideoEmbed } from './styles'

export default function MediaBlock({ resourceUrl, altText, isVideo, isVideoEmbed }) {
  return (
    <MediaContainer>
      {isVideoEmbed ? (
        <HeroVideoEmbed
          src={resourceUrl}
          title={altText}
          allow="autoplay; picture-in-picture; fullscreen"
          sandbox="allow-presentation allow-scripts allow-same-origin allow-popups"
          referrerPolicy="no-referrer-when-downgrade" // youtube requires referrer to embed player
        />
      ) : isVideo ? (
        <HeroVideo src={resourceUrl} alt={altText} controls autoPlay muted loop preload="auto" />
      ) : (
        <HeroImage src={resourceUrl} alt={altText} />
      )}
    </MediaContainer>
  )
}

MediaBlock.propTypes = {
  resourceUrl: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  isVideo: PropTypes.bool.isRequired,
  isVideoEmbed: PropTypes.bool.isRequired,
}
